import { createTheme, DEFAULT_THEME } from '@mantine/core'

import { app_colors } from '@repo/common/core/theme'

export { app_colors }

const inputBackground =
  'light-dark(var(--mantine-color-gray-1),var(--mantine-color-gray-9))'

// https://typescale.com/ 1.25 Major Third
const sizes = {
  xxxs: '0.32rem', // 5
  xxs: '0.512rem', // 8
  xs: '0.64rem', // 10
  sm: '0.8rem', // 12
  md: '1rem', // 16
  lg: '1.25rem', // 20
  xl: '1.56rem', // boundary 28 really 25
  xxl: '1.952rem', // 31
  xl1: '2.441rem',
  xl2: '3.052rem', // 48
  xl3: '3.815rem', // 61
}

// Custom radius values (much smaller than sizes)
const radiusValues = {
  xs: '0.125rem', // 2px
  sm: '0.1875rem', // 3px
  md: '0.25rem', // 4px
  lg: '0.375rem', // 6px
  xl: '0.5rem', // 8px
}

// building in dark so flip light
export const theme = createTheme({
  primaryColor: 'blue',
  primaryShade: {
    light: 5,
    dark: 6,
  },
  defaultGradient: {
    from: 'primary.6',
    to: 'primary.8',
    deg: 106,
  },
  fontFamily: `Lausanne, ${DEFAULT_THEME.fontFamily}`,
  headings: {
    fontFamily: `Lausanne, ${DEFAULT_THEME.fontFamily}`,
    fontWeight: '300',
    sizes: {
      h1: {
        fontSize: sizes.xl,
        lineHeight: '1',
      },
      h2: {
        fontSize: sizes.sm,
        lineHeight: '2.0',
      },
      h3: {
        fontSize: sizes.sm,
        lineHeight: '2.0',
      },
      h4: {
        fontSize: sizes.sm,
        lineHeight: '2.0',
      },
      h5: {
        fontSize: sizes.sm,
        lineHeight: '2.0',
      },
      h6: {
        fontSize: sizes.sm,
        lineHeight: '2.0',
      },
    },
  },
  fontSizes: {
    ...sizes,
    title_xs: sizes.xl,
    title_sm: sizes.xxl,
    title_md: sizes.xl1,
    title_lg: sizes.xl2,
    title_hero: sizes.xl3,
  },
  lineHeights: {
    xs: '1.42',
    sm: '1.71',
    md: '1.87',
    lg: '2.0',
    xl: '1.0',
    title_xs: '1.0',
    title_sm: '1.0',
    title_md: '1.0',
    title_lg: '1.0',
    title_hero: '1.0',
  },
  defaultRadius: 'xs',
  radius: radiusValues, // Use our custom radius values instead of inheriting from sizes
  spacing: sizes,
  other: {},
  components: {
    NumberInput: {
      styles: () => ({
        input: {
          backgroundColor: inputBackground,
        },
      }),
    },
    TextInput: {
      styles: () => ({
        input: {
          backgroundColor: inputBackground,
        },
      }),
    },
    Select: {
      styles: () => ({
        input: {
          backgroundColor: inputBackground,
        },
      }),
    },
    DateInput: {
      styles: () => ({
        input: {
          backgroundColor: inputBackground,
        },
      }),
    },
    DateTimePicker: {
      styles: () => ({
        input: {
          backgroundColor: inputBackground,
        },
      }),
    },
    Autocomplete: {
      styles: () => ({
        input: {
          backgroundColor: inputBackground,
        },
      }),
    },
    Textarea: {
      styles: () => ({
        input: {
          backgroundColor: inputBackground,
          // '&:disabled': {
          //   '[data-mantine-color-scheme="dark"] &': {
          //     color: 'var(--mantine-color-gray-4)',
          //     backgroundColor: 'var(--mantine-color-dark-6)',
          //   },
          // },
        },
      }),
    },
  },
})

// export type CustomColors = keyof typeof app_colors
//
// export type Shades = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9
//
// export type CustomColorsShades = `${CustomColors}.${Shades}`
//
// declare module '@mantine/core' {
//   export interface MantineThemeColorsOverride {
//     // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
//     colors: Record<CustomColors | string, MantineColorsTuple>
//   }
// }
